import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'imagem-responsiva',
  templateUrl: './imagem-responsiva.component.html',
})
export class ImagemResponsivaComponent implements OnInit {

  @Input() mobileUrl: string;
  @Input() tabletUrl: string;
  @Input() fullUrl: string;
  @Input() imageEntity: any;
  @Input() alt: string;
  @Output() preloadEvent = new EventEmitter<string>();

  ngOnInit() {
    if (this.imageEntity) {
      this.mobileUrl = this.imageEntity.thumbnail ? this.imageEntity.thumbnail.source_url : this.imageEntity.canvas.source_url;
      this.tabletUrl = this.imageEntity.canvas ? this.imageEntity.canvas.source_url : this.imageEntity.full.source_url;
      this.fullUrl = this.imageEntity.full.source_url;
    }
  }

  preload() {
    this.preloadEvent.next();
  }
}
